<template>
  <div class="textbox-input">
    <input class="textbox-input__input" v-model="text" type="text" :name="field.Key" placeholder="Enter searched text...">
  </div>
</template>

<script>
export default {
  name: "TextboxInput",
  props: ['field', 'value'],
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/scss/variables';

.textbox-input {
  flex-basis: 55%;
  flex:0 0 55%;
  @media (max-width: 767px) {
    width: 100%;
  }
  &__input {
    font-family: $main-font;
    flex-basis: 55%;
    height: 40px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    outline: none;
    border-width: 1px;
    border-style: solid;   
    padding: 0 15px;
    flex-shrink: 0;
    transition: 0.2s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-inputs/TextboxInput.vue